import axios from 'axios';
import apiConfig from '../../api.config';

export default function bookingReportgetDownloadFiles({ hotelId, booking = null, date }) {
  // Returns a .ZIP
  const {
    host,
    URIs: { bookingReportGetFiles },
  } = apiConfig;

  const uri = `${host}${bookingReportGetFiles}`;

  return axios
    .post(uri, JSON.stringify({ hotelId, booking, date }), {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => {
      return res.data;
    });
}
